import { Injectable } from '@angular/core';

import { HttpErrorResponse, HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ToastService } from '../services/toaster-service';
import { SessaoService } from '../services/sessao.service';

/** Origem da API: o Bearer só vai para ela (antes ia também para o ViaCEP). */
const ORIGEM_API = new URL(environment.APIEndpoint).origin;

/** Rotas da sessão: não levam Bearer nem disparam renovação (são elas que renovam). */
const ROTAS_SESSAO = /\/auth\/(login|refresh|logout)(\?|$)/i;

@Injectable()
export class Interceptor implements HttpInterceptor {

  constructor(private router: Router, private toastService: ToastService, private sessao: SessaoService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.levaToken(request.url)) {
      return next.handle(request).pipe(catchError((erro) => this.tratarErro(erro)));
    }

    // Token vencendo: renova antes de enviar (uma renovação para todas as chamadas da vez).
    return from(this.sessao.tokenParaEnvio()).pipe(
      switchMap((token) => next.handle(this.comToken(request, token)).pipe(
        catchError((erro) => {
          // 401 com sessão: o token pode ter vencido no caminho (relógio, aba suspensa). Renova e
          // repete UMA vez. O 401 vem da autenticação, antes do handler: repetir não grava em dobro.
          if (erro instanceof HttpErrorResponse && erro.status === 401 && token) {
            return from(this.sessao.renovar()).pipe(
              switchMap((novo) => novo
                ? next.handle(this.comToken(request, novo))
                : throwError(() => erro))
            );
          }
          return throwError(() => erro);
        })
      )),
      catchError((erro) => this.tratarErro(erro))
    );
  }

  private levaToken(url: string): boolean {
    if (ROTAS_SESSAO.test(url)) return false;
    try {
      return new URL(url, window.location.href).origin === ORIGEM_API;
    } catch {
      return false;
    }
  }

  private comToken(request: HttpRequest<any>, token: string | null): HttpRequest<any> {
    return token
      ? request.clone({ setHeaders: { Authorization: 'Bearer ' + token } })
      : request;
  }

  private tratarErro(error: any): Observable<never> {
    this.toastService.showToast(
      'Erro',
      error?.error?.message || 'Ocorreu um erro inesperado!',
      'error'
    );

    if (error?.status === 401) {
      console.log('Unauthorized');
      this.router.navigateByUrl('/autenticacao/login');
    }
    return throwError(() => error);
  }
}
